"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardInfo = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
exports.CardInfo = ({ className = '', header, headerSize = 'md', content }) => {
    return (React.createElement("div", { className: `clp-card-info ${className}` },
        header && React.createElement("div", { className: `clp-card-info__header clp-card-info__header_size_${headerSize} pb-24'` }, header),
        content && React.createElement("div", null, content)));
};
//# sourceMappingURL=CardInfo.js.map